






























































































































































import { cloneDeep } from 'lodash-es';
import { CourseDifficulty, CourseType, EntityStatus } from '@adobe/edex/ui/shared/frontend/utils/types';

import changeLogMixin from '@adobe/edex/frontend/views/course/settings/mixin';
import { I18nKey } from '@adobe/edex/ui/shared/constants/i18n';

const getInitialState = (initialCourse) => ({
  settings: cloneDeep(initialCourse.settings),
  difficulty: initialCourse.difficulty,
  status: initialCourse.status,
  type: initialCourse.type,
  sessionID: initialCourse.sessionID,
  ncesID: initialCourse.ncesID,
  schoolDistrict: initialCourse.schoolDistrict,
  title: initialCourse.title,
  vanityURL: initialCourse.vanityURL,
  description: initialCourse.description,
  shortDescription: initialCourse.shortDescription,
  CourseDifficulty,
  CourseType,
  EntityStatus,
  courseType: initialCourse.courseType,
  typei18nKey: I18nKey.typeKey,
  sessionIDi18nKey: I18nKey.sessionId,
  ncesIDi18nKey: I18nKey.ncesId,
});

export default {
  mixins: [changeLogMixin],
  props: {
    initialCourse: {
      type: Object,
      required: true,
    },
  },
  components: {
    VueEditor: () =>
      import(/* webpackChunkName: "externals" */ 'vue2-editor').then(
        ({ VueEditor }) => VueEditor
      ),
  },
  data() {
    return getInitialState(this.initialCourse);
  },
  methods: {
    handleToggle(name, value) {
      this.settings[name] = value;
    },
    resetChanges() {
      Object.assign(this.$data, getInitialState(this.initialCourse));
    },
  },
  watch: {
    ...[
      'enableAutoGrade',
      'enableHelpAndSupport',
      'enableLearningJournal',
    ].reduce((acc, name) => {
      acc[`settings.${name}`] = function (current, previous) {
        if (previous !== current) {
          this.onChange({
            name,
            data: current,
            path: ['settings', name],
            hasDiff: this.initialCourse.settings[name] !== current,
          });
        }
      };

      return acc;
    }, {}),
    ...['difficulty', 'type', 'vanityURL', 'description', 'shortDescription', 'status'].reduce((acc, name) => {
      acc[name] = function (current, prev) {
        if (prev !== current) {
          this.onChange({
            name,
            data: current,
            hasDiff: this.initialCourse[name] !== current,
          });
        }
      };

      return acc;
    }, {}),
    title(current, prev) {
      if (prev !== current) {
        this.onChange({
          name: 'title',
          data: current,
          hasDiff: this.initialCourse.title !== current,
        });
      }
    },
  },
};
